module.exports = {
    calendar: "Kalender",
    today: "Heute",
    yesterday: "Gestern",
    last7days: "Letzte 7 Tage",
    last14days: "Letzte 14 Tage",
    delete_all: "Alles klären",
    log_in: "Anmelden",
    save: "Speichern",
    close: "Schließen",
    today_stats: "heute",
    week: "woche",
    month: "monat",
    year: "jahr",
    this_year: "Dieses Jahr",
    monthly: "monatlich",
    daily: "täglich",
    hourly: "stündlich",
    add_new_object: "Fügen Sie ein neues Objekt hinzu",
    latitude: "Latitude",
    longitude: "Longitude",
    current_password: "Aktuelles Passwort",
    new_password: "Neues Passwort",
    change_password: "Passwort ändern",
    language_select: "Sprache",
    last_year: "Letztes Jahr",
    delete: "Löschen",
    save_profile: "Profil sichern",
    yes: "Ja",
    cancel: "Stornieren",
    add_new_group: "Neue Gruppe hinzufügen",
    automatic_learn: "Automatisches Lernen",
    delete_all_imprints: "Löschen Sie alle Geräteabdrücke",
    turn_on: "Anschalten",
    turn_off: "Schalte aus",
    delete_energy: "Energie löschen",
    next: "Nächster",
    back: "zurück",
    boot_msg: "Boot-Nachricht",
    force_drsf: "Macht",
    add_test_case: "Testfall hinzufügen",
    select: "Wählen",
    profile: "Profil",
    group: "Gruppe",
    start_test: "Starten Sie den Test",
    generate_new_token: "Generieren Sie ein neues Token",
    generate: "Generieren",
    auto_restart: "Automatischer Neustart",
    no_group: "keine Gruppe",
    upgrade: "Aktualisierung",
    upgrade_offline: "Upgrade (Gerät offline)",
    create_swich: "Schalter erstellen",
    change_map: "Karte ändern",
    edit_mode: "Bearbeitungsmodus",
    select_image: "Bild auswählen",
    add: "Hinzufügen"
}